export default __webpack_public_path__ + "static/main-afa0f43e2122d155c79785bd911d126d.png";